import { call, put } from "redux-saga/effects";
import { resetApiError, riseError } from "store/features/general/general.actions";
import {
    validateTemplate as validateTemplateAPI,
    getTemplateDetails,
    TemplateValidationResult,
    createOrUpdateTemplate,
    TemplateDefinition,
} from "api";
import { updateTemplate, fetchTemplateDetails, validateTemplate, createTemplate } from "./definition.actions";
import beautify from "js-beautify";
import { fetchTemplatesSaga } from "store/features/templates/overivew";

export function* fetchTemplateDetailsSaga(
    headers: HeadersInit,
    action: ReturnType<typeof fetchTemplateDetails.request>
): Generator {
    try {
        const templateDefinition = (yield call(
            getTemplateDetails,
            action.payload.templateName,
            headers
        )) as TemplateDefinition;
        yield put(
            fetchTemplateDetails.success({
                ...templateDefinition,
                parsedXml: beautify.html(templateDefinition.text || "", { indent_size: 4 }),
            })
        );
    } catch (err) {
        if (err.status) {
            yield put(fetchTemplateDetails.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* updateTemplateSaga(
    headers: HeadersInit,
    action: ReturnType<typeof updateTemplate.request>
): Generator {
    try {
        yield call(createOrUpdateTemplate, action.payload, headers);
        yield put(updateTemplate.success());
        // reload templates
        yield call(fetchTemplatesSaga, headers);
    } catch (err) {
        if (err.status) {
            yield put(updateTemplate.failure({ statusCode: err.status, message: err.parsedError.error }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* validateTemplateSaga(
    headers: HeadersInit,
    action: ReturnType<typeof validateTemplate.request>
): Generator {
    try {
        const { preview } = (yield call(validateTemplateAPI, action.payload, headers)) as TemplateValidationResult;
        yield put(validateTemplate.success({ preview }));
    } catch (err) {
        if (err.status) {
            yield put(validateTemplate.failure({ statusCode: err.status, message: err.parsedError.error }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* createTemplateSaga(
    headers: HeadersInit,
    action: ReturnType<typeof createTemplate.request>
): Generator {
    try {
        yield call(createOrUpdateTemplate, action.payload, headers);
        yield put(createTemplate.success());
        // reload templates
        yield call(fetchTemplatesSaga, headers);
    } catch (err) {
        if (err.status) {
            yield put(createTemplate.failure({ statusCode: err.status, message: err.parsedError.error }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
